define('modules/form_editor/models/custom_telephone',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "custom:telephone",
    defaultValues: {
      "placeholder": "",
      "variable": ""
    },
    defaultErrorMsgKey: "formEditor.validationMessages.phone",
  });
});

